import { API_ROOT } from 'src/constants';
import Request, { setData, setMethod, setURL } from '../index';
import {AdditionalLoan} from "src/types/AdditionalLoan";
import {getNamespaceName} from "src/services/objects/namespaces";

/**
 * createAdditionalLoan
 *
 * Create additional loan data in existing loan
 */

export const createAdditionalLoan = (data: Partial<AdditionalLoan>) =>
  Request<AdditionalLoan>(
    setURL(`${API_ROOT}/${getNamespaceName()}/additional_loans`),
    setMethod('POST'),
    setData(data)
  ).then((response) => response.data);

/**
 * updateAdditionalLoan
 *
 * Update additional loan data
 */

export const updateAdditionalLoan = (data: Partial<AdditionalLoan>) =>
  Request<AdditionalLoan>(
    setURL(`${API_ROOT}/${getNamespaceName()}/additional_loans/${data.id}`),
    setMethod('PUT'),
    setData(data)
  ).then((response) => response.data);

/**
 * deleteAdditionalLoan
 *
 * Delete additional loan data
 */

export const deleteAdditionalLoan = (id: string) =>
  Request<any>(
    setURL(`${API_ROOT}/${getNamespaceName()}/additional_loans/${id}`),
    setMethod('DELETE'),
  ).then((response) => response.data);
